export default {
  head_scripts: {
    title: 'Head Scripts',
  },
  body_noscripts: {
    title: 'Body noscripts',
    description: 'Inject code immediately after opening body',
  },
  google_site_verification: {
    title: 'Google Site Verification',
    label: 'Google Site Verification Code',
  },
  buttons: {
    save: 'Save',
  },
};
